import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import index from "./index.css";
import 'bootstrap/dist/css/bootstrap.min.css';


ReactDOM.render(
  <React.StrictMode>
      <BrowserRouter>
          <style>
              @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,700;0,900;1,400;1,700;1,900&display=swap');
          </style>
          <App/>
      </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
